import React, { useRef } from "react"
import { RelatedContentShadowCard, RelatedContentOverlayCard } from "../Cards"
import { RelatedNewsContainer } from "./style"
import { useIntersectionObserver, useUnsetGrid } from "../hooks"
import RelatedContentTitle from "../Title"

const RelatedNews = ({
	title  /* title */,
	titleUrl,
	titleUrlTarget,
	subtitle,
	listFrom /* auto or manual*, if auto get from auto, if manual get manual*/,
	manual /* list of manual contentTeasers */,
	auto /* list of automatic contentTeasers*/,
	relatedContentSectionHtmlId /* div id */,
	showHighlightedDescription,
	showDate,
	linkText
}) => {
	const newsRef = useRef(null)
	const animate = useIntersectionObserver(newsRef)
	const contentList = (listFrom === 'auto') ? auto : manual;
	useUnsetGrid(newsRef)
	if (contentList.length === 0) return <div style={{ minHeight: '50px', display: 'flex', alignItems: 'center' }}><p>
		No content available, please check the authoring dialog.
	</p></div>
	const list = [...contentList]
	const first = list.find(i => i.manualHighlight) || list[0];
	const remaining = first ? list.filter(item => item !== first): list;

	return <RelatedNewsContainer ref={newsRef} id={relatedContentSectionHtmlId}>
		<RelatedContentTitle title={title} titleUrl={titleUrl} titleUrlTarget={titleUrlTarget} subtitle={subtitle} />
		{(contentList?.length > 0) && <div className={`rel-content__section__items ${animate ? "animated" : ""}`}>
			{first && (
      			<RelatedContentOverlayCard
      				linkText={linkText}
      				showHighlightedDescription={showHighlightedDescription} showDate={showDate}
      				content={first}
      				highlighted={true}
      				type="news"
      			/>
      		)}
			<div className="rel-content__section__items__grid">
      			{remaining.slice(0, 4).map((content, index) => (
      				<RelatedContentShadowCard
      					key={index}
      					linkText={linkText}
      					content={content}
								showDate={showDate}
      					type="news"
      				/>
      			))}
      		</div>
      	</div>}
      </RelatedNewsContainer>
}

export default RelatedNews
